// src/styles/GlobalStyle.js
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
    }
    html, body, #root {
        height: 100%;
    }
    html {
        scroll-behavior: smooth;
    }
    body {
        margin: 0;
        color: #111;
        background: #fff;
        font-family: system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji";
    }
    a {
        color: inherit;
        text-decoration: none;
    }
`;

export default GlobalStyle;
